import { red } from 'styles/colors';

export const activeHighlightBoxShadow = `box-shadow: 0px 2px 10px 0px ${red}`;
export const defaultLeftMargin = 10;
